import _defineProperty from "/www/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { clean } from '../clean-stores/index.js';
var START = 0;
var STOP = 1;
var SET = 2;
var NOTIFY = 3;
var BUILD = 4;
var MOUNT = 5;
var UNMOUNT = 6;
var REVERT_MUTATION = 10;
var on = function on(object, listener, eventKey, mutateStore) {
  object.events = object.events || {};
  if (!object.events[eventKey + REVERT_MUTATION]) {
    object.events[eventKey + REVERT_MUTATION] = mutateStore(function (eventProps) {
      // eslint-disable-next-line no-sequences
      object.events[eventKey].reduceRight(function (event, l) {
        return l(event), event;
      }, _objectSpread({
        shared: {}
      }, eventProps));
    });
  }
  object.events[eventKey] = object.events[eventKey] || [];
  object.events[eventKey].push(listener);
  return function () {
    var currentListeners = object.events[eventKey];
    var index = currentListeners.indexOf(listener);
    currentListeners.splice(index, 1);
    if (!currentListeners.length) {
      delete object.events[eventKey];
      object.events[eventKey + REVERT_MUTATION]();
      delete object.events[eventKey + REVERT_MUTATION];
    }
  };
};
export var onStart = function onStart(store, listener) {
  return on(store, listener, START, function (runListeners) {
    var originListen = store.listen;
    store.listen = function (arg) {
      if (!store.lc && !store.starting) {
        store.starting = true;
        runListeners();
        delete store.starting;
      }
      return originListen(arg);
    };
    return function () {
      store.listen = originListen;
    };
  });
};
export var onStop = function onStop(store, listener) {
  return on(store, listener, STOP, function (runListeners) {
    var originOff = store.off;
    store.off = function () {
      runListeners();
      originOff();
    };
    return function () {
      store.off = originOff;
    };
  });
};
export var onSet = function onSet(store, listener) {
  return on(store, listener, SET, function (runListeners) {
    var originSet = store.set;
    var originSetKey = store.setKey;
    if (store.setKey) {
      store.setKey = function (changed, changedValue) {
        var isAborted;
        var abort = function abort() {
          isAborted = true;
        };
        runListeners({
          abort: abort,
          changed: changed,
          newValue: _objectSpread(_objectSpread({}, store.value), {}, _defineProperty({}, changed, changedValue))
        });
        if (!isAborted) return originSetKey(changed, changedValue);
      };
    }
    store.set = function (newValue) {
      var isAborted;
      var abort = function abort() {
        isAborted = true;
      };
      runListeners({
        abort: abort,
        newValue: newValue
      });
      if (!isAborted) return originSet(newValue);
    };
    return function () {
      store.set = originSet;
      store.setKey = originSetKey;
    };
  });
};
export var onNotify = function onNotify(store, listener) {
  return on(store, listener, NOTIFY, function (runListeners) {
    var originNotify = store.notify;
    store.notify = function (changed) {
      var isAborted;
      var abort = function abort() {
        isAborted = true;
      };
      runListeners({
        abort: abort,
        changed: changed
      });
      if (!isAborted) return originNotify(changed);
    };
    return function () {
      store.notify = originNotify;
    };
  });
};
export var onBuild = function onBuild(Template, listener) {
  return on(Template, listener, BUILD, function (runListeners) {
    var originBuild = Template.build;
    Template.build = function () {
      var store = originBuild.apply(void 0, arguments);
      runListeners({
        store: store
      });
      return store;
    };
    return function () {
      Template.build = originBuild;
    };
  });
};
export var STORE_UNMOUNT_DELAY = 1000;
export var onMount = function onMount(store, initialize) {
  var listener = function listener(payload) {
    var destroy = initialize(payload);
    if (destroy) store.events[UNMOUNT].push(destroy);
  };
  return on(store, listener, MOUNT, function (runListeners) {
    var originListen = store.listen;
    store.listen = function () {
      if (!store.lc && !store.active) {
        store.active = true;
        runListeners();
      }
      return originListen.apply(void 0, arguments);
    };
    var originOff = store.off;
    store.events[UNMOUNT] = [];
    store.off = function () {
      setTimeout(function () {
        if (store.active && !store.lc) {
          store.active = false;
          var _iterator = _createForOfIteratorHelper(store.events[UNMOUNT]),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var destroy = _step.value;
              destroy();
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          store.events[UNMOUNT] = [];
          originOff();
        }
      }, STORE_UNMOUNT_DELAY);
    };
    if (process.env.NODE_ENV !== 'production') {
      var originClean = store[clean];
      store[clean] = function () {
        var _iterator2 = _createForOfIteratorHelper(store.events[UNMOUNT]),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var destroy = _step2.value;
            destroy();
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        store.events[UNMOUNT] = [];
        store.active = false;
        originClean();
      };
    }
    return function () {
      store.listen = originListen;
      store.off = originOff;
    };
  });
};